import { ContentCardStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import {
  BlokProps,
  getLink,
  StoryblokComponent,
} from "@frend-digital/storyblok";
import styles from "../index.module.css";

export const ContentCardBlok = ({
  blok,
  preview,
}: BlokProps<ContentCardStoryblok>) => {
  const href = getLink(blok.link)?.href;
  const { media, title, text } = blok;

  return (
    <div className={`${styles.content__card}`}>
      {media?.[0] && <StoryblokComponent blok={media[0]} preview={preview} />}
      {title && <h3>{title}</h3>}
      {text && href ? <Link href={href}>{text}</Link> : <p>{text}</p>}
    </div>
  );
};
